import { request } from '../axios/request';

import {
  FETCH_ORDER_ACCEPT_PENDING,
  FETCH_ORDER_ACCEPT_REJECTED,
  FETCH_ORDER_ACCEPT_FULFILLED,
} from '../constants/orderAccept';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_ORDER_ACCEPT_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_ORDER_ACCEPT_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_ORDER_ACCEPT_REJECTED,
  error: error,
});

export const acceptOrder = (orderPk, data) => (dispatch) => {
  dispatch(pending());

  request({
    method: 'post',
    url: `${$U.ORDER_ACCEPT}${orderPk}`,
    data: data,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/orderAccept.js